import Gateway from '@/utils/Gateway';

// 获取绑定状态和企业微信账号信息
export default function getBindInfo() {
    return new Promise((resolve, reject) => {
        Gateway.get('/v1/corp/wework/CorpInfo')
            .then(data => {
                // status 0为已绑定 1为未绑定
                const { status } = data || {};
                let isBind = false;
                let corpInfo = {};
                let isNew = false;

                if (status === 0) {
                    isBind = true;
                    corpInfo = data || {};
                    isNew = corpInfo.is_new;
                }

                corpInfo.isVerify = corpInfo.corp_type === 'verified';

                resolve({
                    isBind,
                    isNew,
                    corpInfo
                });
            })
            .catch(e => {
                reject(e);
            });
    });
}
